import React, { useState } from 'react';
import { apiClient } from '../api/client';

const styles: Record<string, React.CSSProperties> = {
  container: { padding: '0.5rem 0' },
  row: { display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' },
  field: { display: 'flex', flexDirection: 'column', gap: '0.25rem' },
  label: { fontSize: '0.8rem', fontWeight: 600, color: '#333' },
  input: {
    padding: '0.5rem 0.75rem',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '0.9rem',
    width: '80px',
  },
  select: {
    padding: '0.5rem 0.75rem',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '0.9rem',
  },
  btn: {
    padding: '0.5rem 1.25rem',
    backgroundColor: '#1a6b3c',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.9rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  result: {
    marginTop: '1rem',
    padding: '0.75rem 1rem',
    backgroundColor: '#f0faf4',
    border: '1px solid #c8e6c9',
    borderRadius: '6px',
    fontSize: '0.85rem',
  },
  error: {
    marginTop: '1rem',
    padding: '0.75rem 1rem',
    backgroundColor: '#fef0f0',
    border: '1px solid #f5c6cb',
    borderRadius: '6px',
    fontSize: '0.85rem',
    color: '#d32f2f',
  },
  info: {
    marginTop: '0.75rem',
    fontSize: '0.8rem',
    color: '#666',
  },
};

export function GenerateTestAccounts() {
  const [count, setCount] = useState(5);
  const [role, setRole] = useState<string>('Delegate');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{ count: number; password: string } | null>(null);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const res = await apiClient<{ count: number; password: string }>('/users/generate-test-accounts', {
        method: 'POST',
        body: { count, role },
      });
      setResult({ count: res.count, password: res.password });
    } catch (err: unknown) {
      const apiErr = err as { message?: string };
      setError(apiErr?.message || 'Failed to generate test accounts');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.row}>
        <div style={styles.field}>
          <label style={styles.label}>Count</label>
          <input
            type="number"
            min={1}
            max={50}
            value={count}
            onChange={(e) => setCount(Number(e.target.value))}
            style={styles.input}
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Role</label>
          <select value={role} onChange={(e) => setRole(e.target.value)} style={styles.select}>
            <option value="Attendee">Attendee</option>
            <option value="Delegate">Delegate</option>
            <option value="Organizer">Organizer</option>
          </select>
        </div>
        <button
          onClick={handleGenerate}
          disabled={loading || count < 1}
          style={{ ...styles.btn, ...(loading ? styles.btnDisabled : {}) }}
        >
          {loading ? 'Generating...' : 'Generate'}
        </button>
      </div>
      <p style={styles.info}>
        Creates accounts with pattern: test1.lastname1@kdu-georgia.org, test2.lastname2@kdu-georgia.org, etc.
        Existing accounts are updated (idempotent).
      </p>
      {result && (
        <div style={styles.result}>
          ✓ Created {result.count} test accounts. Password: <strong>{result.password}</strong>
        </div>
      )}
      {error && <div style={styles.error}>{error}</div>}
    </div>
  );
}
